import { FC } from "react";
import { PreliminaryInquiry } from "types";
import { DateView } from "utils/helper";

type Props = {
  preliminary: PreliminaryInquiry;
  onClose: () => void;
};

const PreliminaryDetail: FC<Props> = ({ preliminary, onClose }) => {
  // const handleClickOutside = (e: any) => {
  //   if (e.target.classList.contains("fixed")) {
  //     onClose();
  //   }
  // };

  return (
    <div>
      <h2 className="mb-1 text-2xl font-semibold text-[#E90101]">
        Preliminary Request
      </h2>
      <p className="mb-6 text-xs font-light text-[#9D9D9D] max-w-sm">
        Lorem Ipsum is a placeholder text commonly used in the design and
        publishing industries as a temporary filler.
      </p>

      {[
        {
          property: "Court Name",
          value: preliminary?.court_name,
        },
        {
          property: "Body Receiving the copy",
          value: preliminary?.body_receiving_the_copy,
        },
        {
          property: "Inquiry Date",
          value: DateView(preliminary?.inquiry_date),
        },
        {
          property: "Findings",
          value: preliminary?.findings,
        },
        {
          property: "Reason for Preliminary Inquiry",
          value: preliminary?.reason_for_preliminary_inquiry,
        },
        {
          property: "Applying Prosecutor",
          value: preliminary?.applying_prosecutor,
        },
      ]?.map((info, index) => (
        <div
          key={index}
          className="flex flex-row gap-4 mt-3 items-start justify-between border-b border-b-[#E9E9E9] pb-3"
        >
          <p className="font-normal text-base text-[#0A1D39]">
            {info?.property}
          </p>
          <p className="font-normal text-base text-[#0A1D39]">
            {typeof info?.value === "boolean" || typeof info?.value === "object"
              ? info?.value ?? "-"
              : info?.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PreliminaryDetail;
